// import EmailIcon from '@mui/icons-material/Email';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import fontsStyles from '../../styles/fontStyles';
import useStyles from './styles';

const TeamMember = ({ member }) => {
  const fontClasses = fontsStyles();
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.memberBox}>
      <Box className={classes.coverImgBox}>
        <img src={member.photo.url} className={classes.coverImg} />
      </Box>
      <Box className={classes.memberInformartion}>
        <p className={clsx(fontClasses.p, classes.memberTitle)}>{member.name}</p>
        <p className={clsx(fontClasses.p, classes.memberPosition)}>{member.position}</p>
        <p className={clsx(fontClasses.p, classes.memberCompany)}>
          <b>{`${t('historyPage.business')}: `}</b>
          {member.business}
        </p>
        <p className={clsx(fontClasses.p, classes.memberCompany)}>
          <b>{`${t('historyPage.experience')}: `}</b>
        </p>
        {member.experience.map((exp, index) => {
          return (
            <p key={index} className={clsx(fontClasses.p, classes.memberExperience)}>
              {'\u2022 '}
              {exp}
            </p>
          );
        })}
        <p className={clsx(fontClasses.p, classes.memberText)}></p>
      </Box>
    </Box>
  );
};

export default TeamMember;
